// extracted by mini-css-extract-plugin
export default {"navBarDiv":"NavBar_navBarDiv__DCoVb","sideBarDiv":"NavBar_sideBarDiv__sQ16N","headingH1":"NavBar_headingH1__U-FRk","userH1":"NavBar_userH1__Wanb5"};